module.exports = __webpack_public_path__ + "img/gl.49bbd69c.svg";